(function() {
  $(document).on("swell:setup", function() {
    Swell.Redemption.initializeRedemptions(".redemption-list", {
      templates: {
        redemptionOption: "<li class=\"swell-redemption-option\">\n  <div\n    class=\"swell-redemption-option-content\"\n    data-redemption-option-id=\"<%= redemption.id %>\">\n    <div class=\"swell-redemption-option-value\"><%= redemption.name %></div>\n    <div class=\"swell-redemption-option-cost\"><%= redemption.cost_text %></div>\n  </div>\n</li>"
      }
    });
    SwellConfig.Redemption.initializeRedemptionAction();
    Swell.Referral.initializeReferral(".referral", {
      localization: {
        referralRegisterHeading: "Refer A Friend",
        referralCopyLinkHeading: "Copy Link",
        referralReferHeading: "Refer A Friend",
        referralRegisterFormDetails: "Enter your email below."
      }
    });
    $('.referral-image').appendTo('.swell-referral-content-sidebar')
    $('.referral-image').show();

    // Subscription items are just for inline cart, so don't show them here
    $('.redemption-list li').each(function(index, item) {   
      if($(this).find('.swell-redemption-option-value:contains("Subscription")').length > 0) {    
        $(this).remove();   
      }   
    });

    return Swell.Campaign.initializeCampaigns(".campaign-list");
  });

}).call(this);

(function() {
  $(document).on("swell:setup", function() {
    Swell.Referral.initializeReferral($(".account-referral"), {
      localization: {
        referralRegisterHeading: "Refer A Friend",
        referralCopyLinkHeading: "Copy Link",
        referralReferHeading: "Refer A Friend"
      }
    });
    $(".account-referral .swell-referral-content-sidebar").append("<div class=\"swell-referral-account-details\">\n  <h3 class=\"referral-points\">Points: <span class=\"swell-point-balance\"></span></h3>\n  <button class=\"referral-history-link\">Rewards History</button>\n</div>");
    return swellAPI.refreshEmbeds();
  });

}).call(this);

// (function() {
//   $(document).on("swell:setup", function() {
//     var encouragement, points_balance;
//     encouragement = null;
//     points_balance = swellAPI.getCustomerDetails().pointsBalance;
//     if (!spapi.authenticated) {
//       encouragement = "<div class=\"encouragement encouragement-login\">\n  <a href=\"/pages/rewards\" class=\"encouragement-content\"><i class=\"fa fa-heart\" aria-hidden=\"true\"></i>&nbsp;Earn Rewards</a>\n</div>";
//     } else {
//       encouragement = "<div class=\"encouragement encouragement-promo\">\n  <a href=\"/pages/rewards\" class=\"encouragement-content\">MY REWARDS: <span>" + points_balance + " points</span></a>\n</div>";
//     }
//     $(".main_top_header").append(encouragement);
//     return $("header").addClass("has-encouragement");
//   });

// }).call(this);

(function() {
  $(document).on("swell:setup", function() {
    return $(document).on("click", ".referral-history-link", function(e) {
      e.preventDefault();
      return swellAPI.showPopupByType("HistoryPopup");
    });
  });

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  window.SwellConfig.Redemption = {
    initializeRedemptionAction: function() {
      var redemption_option_cta;
      redemption_option_cta = spapi.authenticated ? "Redeem Now" : "Login or Signup";
      $(".swell-redemption-option-content").append("<div class=\"swell-redemption-option-cta\">" + redemption_option_cta + "</div>");
      return $(document).on("click", ".logged-in .swell-redemption-option-content", function() {
        return window.location.href = spapi.authenticated ? "/checkout" : "/account";
      });
    }
  };

}).call(this);

(function() {
  var classNames, selectors,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  classNames = {
    container: "question-content",
    heading: "question-text",
    section: "question-response",
    open: "question-open"
  };

  selectors = {
    container: "." + classNames.container,
    heading: "." + classNames.heading,
    section: "." + classNames.section,
    open: "." + classNames.open
  };

  $(document).ready(function() {
    var hash, heading, openCollapsiblesForAnchor, toHide;
    openCollapsiblesForAnchor = function(hash, redirect) {
      var anchors, el, name;
      name = hash.substr(1);
      anchors = $(selectors.container).find(hash + ", a[name=\"" + name + "\"]");
      if (anchors.length > 0) {
        el = $(anchors[0]);
        el.closest(selectors.container).find(selectors.heading).click();
        return el.closest(selectors.section).promise().done(function() {
          return window.location = redirect;
        });
      } else if ($(hash).is(selectors.container)) {
        return $(hash).find(selectors.heading).click();
      }
    };
    $(selectors.container).css("overflow", "hidden");
    toHide = $(selectors.container).not(selectors.open).find(selectors.section);
    heading = $(selectors.heading);
    toHide.hide();
    heading.css("cursor", "pointer");
    heading.click(function() {
      var parent, t;
      t = $(this);
      parent = t.parent();
      if (parent.hasClass(classNames.open)) {
        parent.removeClass(classNames.open);
        t.attr("aria-expanded", "false");
      } else {
        parent.addClass(classNames.open);
        t.attr("aria-expanded", "true");
      }
      t.next().slideToggle("fast");
      return false;
    });
    $(document).keydown(function(e) {
      if ((32 === e.keyCode || 13 === e.keyCode) && $(e.target).hasClass(classNames.heading)) {
        e.preventDefault();
        e.target.click();
        return false;
      }
    });
    if (window.location.hash) {
      hash = window.location.hash;
      openCollapsiblesForAnchor(hash, window.location);
    }
    if (indexOf.call(window, "onhashchange") >= 0) {
      return $(window).bind("hashchange", function(e) {
        hash = window.location.hash;
        return openCollapsiblesForAnchor(hash, window.location);
      });
    }
  });

}).call(this);
